import {IconButton, Tooltip} from "@mui/material";
import {InfoIcon} from 'lucide-react';
import React from 'react';
import {useTranslation} from "react-i18next";
import {Card} from '../../tremor/components/Card';

const colorVariants = {
    gray: {
        text: 'text-gray-400',
        textBold: 'text-gray-400',
        bg: 'bg-gray-50'
    },
    red: {
        text: 'text-ral-red-500',     // RAL 3020 Traffic Red #CC0605
        textBold: 'text-ral-red-500',
        bg: 'bg-ral-red-50'
    },
    yellow: {
        text: 'text-amber-500',     // or RAL 1023 Traffic Yellow #FAD201
        textBold: 'text-amber-500',
        bg: 'bg-amber-50'
    },
    green: {
        text: 'text-ral-green-500',     // RAL 6024 Traffic Green #028A0F
        textBold: 'text-ral-green-500',
        bg: 'bg-ral-green-50'
    },
    blue: {
        text: 'text-primary-600',
        textBold: 'text-primary-600',
        bg: 'bg-blue-50'
    }
};

export const ActivityCard = ({ title, value, percentage, color = "gray" }) => {
    const variant = colorVariants[color] || colorVariants.gray;

    return (
        <Card className="mx-auto max-w-xs h032 text-center font-sans">
            <p className={`${variant.text} text-sm font-bold whitespace-nowrap`}>{title}</p>
            <p className={`${variant.textBold} text-3xl font-bold tracking-tight`}>{value}</p>
            {/* Reserve space for percentage even if not provided */}
            <div className="h-6 flex items-center justify-center w-full">
                {percentage && (
                    <p className={`${variant.text} text-base font-medium text-center`}>
                        {percentage}
                    </p>
                )}
            </div>
        </Card>
    );
};

export const PerformanceCard = ({
                                    actualText,
                                    actualValue,
                                    actualUnit = "",
                                    actualChange,
                                    expectedText,
                                    expectedValue,
                                    expectedUnit = "",
                                    expectedChange,
                                    hasExpectedValues = true
                                }) => {
    const { t } = useTranslation();

    return (
        <div className="tailwind-scope mx-auto max-w-md">
            <div className="w-full grid grid-cols-2 gap-4">
                <Card className="font-sans text-center">
                    <p className="text-sm font-medium text-primary-500 mb-2">
                        {actualText}
                    </p>
                    <p className="text-2xl font-bold text-primary-500">
                        {actualValue}&nbsp;{actualUnit}
                    </p>
                    <p className={`text-sm font-medium ${
                        actualChange.startsWith('-') ? 'text-ral-red-500' : 'text-primary-500'
                    }`}>
                        {actualChange}
                    </p>
                </Card>
                <Card className="font-sans text-center relative">
                    {!hasExpectedValues && (
                        <Tooltip title={t('Reports.Dashboard.NoEstimatesTooEarlyInMonth')}>
                            <IconButton
                                size="small"
                                sx={{ position: 'absolute', top: 4, right: 4, color: 'grey.400' }}
                            >
                                <InfoIcon className="w-4 h-4" color={'#005A92'} />
                            </IconButton>
                        </Tooltip>
                    )}
                    <p className="text-sm font-medium text-gray-400 mb-2">
                        {expectedText}
                    </p>
                    <p className="text-2xl font-bold text-gray-400">
                        {expectedValue}&nbsp;{expectedUnit}
                    </p>
                    <p className={`text-sm font-medium text-gray-400`}>
                        {expectedChange}
                    </p>
                </Card>
            </div>
        </div>
    );
};